import React from "react";
import { Pressable, StyleSheet, View } from "react-native";

type Props = {
  onPress: () => void;
};

export default function AppHeaderMenuButton({ onPress }: Props) {
  return (
    <Pressable
      onPress={onPress}
      hitSlop={12}
      accessibilityRole="button"
      accessibilityLabel="Open menu"
      style={styles.menuButton}
    >
      <View style={styles.burgerLine} />
      <View style={styles.burgerLine} />
      <View style={styles.burgerLine} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  menuButton: {
    // 44x44 minimum touch target (iOS HIG / Android 48dp guidance) so the menu
    // is easy to hit on phones (#128).
    minWidth: 44,
    minHeight: 44,
    paddingLeft: 12,
    paddingVertical: 6,
    alignItems: "flex-end",
    justifyContent: "center",
    gap: 6,
  },
  burgerLine: {
    width: 23.75,
    height: 3.3431668281555176,
    backgroundColor: "#3A6FB1",
    borderRadius: 100,
  },
});
